var __TEMP__ = require('./_asciiSize.js');var asciiSize = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_hasUnicode.js');var hasUnicode = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_unicodeSize.js');var unicodeSize = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */
function stringSize(string) {
  return hasUnicode(string)
    ? unicodeSize(string)
    : asciiSize(string);
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = stringSize;
